import apiPaths from '../api-paths';

export default {
  getByCrmOriginalInPeriod({ period }) {
    return axios.post(`${ apiPaths.UPSTREAM.CRM }/subscription-settlement-items/by-crm-original-in-period`, { period });
  },
};
